export default "__VITE_ASSET__w$_OsFnm__"